var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmailIconLogin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 14,
    viewBox: "0 0 12 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.25 11.7115C11.25 11.9707 11.0813 12.1827 10.875 12.1827H1.125C0.91875 12.1827 0.75 11.9707 0.75 11.7115V2.28846C0.75 2.02933 0.91875 1.81731 1.125 1.81731H10.875C11.0813 1.81731 11.25 2.02933 11.25 2.28846V11.7115ZM11.25 0.875H0.75C0.33375 0.875 0 1.29433 0 1.81731V12.1827C0 12.701 0.33375 13.125 0.75 13.125H11.25C11.6625 13.125 12 12.701 12 12.1827V1.81731C12 1.29433 11.6625 0.875 11.25 0.875ZM8.25 3.70192H9.75V5.58654H8.25V3.70192ZM7.5 6.52885H10.5V2.75962H7.5V6.52885ZM1.5 8.41346H6.75V7.47115H1.5V8.41346ZM1.5 10.2981H6.75V9.35577H1.5V10.2981Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailIconLogin);
export default __webpack_public_path__ + "static/media/emailIconLogin.6063a9a2d9123c2a05c007f2c0b97dcf.svg";
export { ForwardRef as ReactComponent };